import styled from "styled-components";

export const AreaLabel = styled.label`
  position: relative;
  display: flex;
  display: flex !important;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
  > div {
    flex: 1 1 auto;
  }
  div {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .react-select__menu,
  .react-select__menu * {
    white-space: nowrap;
    width: auto;
    min-width: 100%;
    max-width: unset;
  }

  .react-select__menu-list {
    color: ${(props) => props.theme.colors.dark};
  }
`;

export const AreaButton = styled.button`
  flex: 0 0 auto;
  display: flex;
  background: transparent;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.greyDarkBorder};
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0 12px;
  transition: background-color 0.2s ease-in-out;
  background-color: ${(props) => props.theme.colors.white};

  &:hover {
    background-color: ${(props) => props.theme.colors.blue};
    svg {
      color: ${(props) => props.theme.colors.white};
      fill: ${(props) => props.theme.colors.white};
    }
  }
`;

export const QuantityLabel = styled.label`
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  gap: 0;
  width: 100%;
  justify-content: flex-start;
  align-items: stretch;
  > div {
    flex: 1 1 auto;
  }
  div {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

// export const UnitsWrapper = styled.div`
//   display: flex;
// `;

export const UnitButton = styled.button`
  transition: all 0.2s ease-in-out;
  background-color: ${(props) => props.theme.colors.grey};
  &.active span {
    background-color: ${(props) => props.theme.colors.blue};
    color: ${(props) => props.theme.colors.white};
  }
  span {
    flex: 0 0 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    height: 32px;
    width: 32px;

    &:hover {
      background-color: ${(props) => props.theme.colors.blueLight};
      color: ${(props) => props.theme.colors.white};
    }
  }
  flex: 0 0 auto;
  color: ${(props) => props.theme.colors.blue};
  border-radius: 5px;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  border: 1px solid ${(props) => props.theme.colors.greyDarkBorder};
  &:first-of-type {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-left: none;
    border-right: none;
  }
  & + & {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
